module.exports = __webpack_public_path__ + "img/scene_cozy_white_big@2x.a1bc1a14.png";